import React from 'react';

import RoverBrandContext from '@rover/react-lib/src/context/RoverBrandContext';
import { RoverBrand, RoverBrandProviderProps } from '@rover/types';

import { useRoverBrandProvider } from './useRoverBrandProvider';

const RoverBrandProvider = ({
  brand = RoverBrand.Rover, // Default to Rover for native platforms
  children,
}: RoverBrandProviderProps): JSX.Element => {
  const roverBrand = useRoverBrandProvider(brand);
  return <RoverBrandContext.Provider value={roverBrand}>{children}</RoverBrandContext.Provider>;
};

export default RoverBrandProvider;
